import React, { useState, useRef, useEffect, useMemo } from 'react'
import memberLogo from '../../assets/images/Member.png';
import { Link, useParams } from 'react-router-dom';
import backLogo from '../../assets/images/Back.png';
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import { addNewEquationForExistedAgent, getGameTypeEquationByAgentIdService, updateAgentService } from '../../services/agent.service'

import useUserData from '../../hooks/useUserData';
import AgentInput from './components/AgentInput';
import EditEquationCard from './components/EditEquationCard';
import EquationCard from './components/EquationCard';
import NewGameType from './components/NewGameType';
import { getActiveGameTypeService } from '../../services/gametype.service';

const ViewAgent = () => {
    const [expand, setExpand] = useState(false);
    const [expandIndex, setExpandIndex] = useState([]);
    const [userData, setUserData] = useUserData();
    const [follow, setFollow] = useState({ userId: '', name: 'User Name' });
    const [gameTypeEquation, setGameTypeEquation] = useState([]);
    const [agentData, setAgentData]  = useState({
        "agentName": '',
        "userId": '',
        "agentId": ''
    });

    const [currentEquation, setCurrentEquation] = useState({
        equationId: '',
        equation: '',
        exchangeUnitRate: '',
        active: '',
    });

    const [newEquation, setNewEquation] = useState([]);
    const[showNewEquation, setShowNewEquation] = useState(false);

   // const [gameTypeData] = useGameTypeData();
   const [gameTypeData, setGameTypeDate]= useState()

    let agentId = useParams();
    const dispatch = useDispatch();

    const filterGameType = useMemo(() => {
            let gameTypeIds = gameTypeEquation.map(el => el.gameTypeId);
            return gameTypeData && gameTypeData.filter(el => !gameTypeIds.includes(el.gameTypeId));
    }, [gameTypeEquation, gameTypeData]);

    const getActiveGameType = async() => {

        try {
            dispatch(setIsLoading(true))
            const result = await getActiveGameTypeService();
            if(result?.data) {
                setGameTypeDate(result.data)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
            dispatch(setIsLoading(false))
        }
    }


    const getGameTypeEquationByAgentId = async (agentId, signal) => {
        try {
            dispatch(setIsLoading(true))
            const result = await getGameTypeEquationByAgentIdService(agentId, signal);
            if(result.data) {
              setAgentData(result.data.agentData);
              setGameTypeEquation(result.data.gameTypeEquation)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
            dispatch(setIsLoading(false))
        }
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        getGameTypeEquationByAgentId(agentId, signal);
        getActiveGameType()
        return () => {
            controller.abort();
        }
    },[])

    useEffect(() => {
        setFollow({ userId: agentData.userId, name: agentData.username })
    }, [agentData] )


    const handleExpand = (index) => {
        if (expandIndex.includes(index)) {
            setExpandIndex(prevExpandIndex => prevExpandIndex.filter(i => i !== index));
        } else {
            setExpandIndex(prevExpandIndex => [...prevExpandIndex, index]);
        }
    }

    const selectFollower = (e) => {
        e.stopPropagation();
        setExpand(!expand);
    }


    const addOrReplace = (arr, newObj) => {
        if (!arr) return [newObj];
        return [...arr.filter((o) => o.equationId !== newObj.equationId), {...newObj}];
      };


    const handleOnChange = (e) => {
        setAgentData({...agentData, [e.target.name]: e.target.value})
    }

    const handleOnChangeEquation = (e) => {
        if (e.target.name == "showPositive") {
            return setCurrentEquation({...currentEquation, [e.target.name]: e.target.checked})
        }
        setCurrentEquation( {...currentEquation, [e.target.name]: e.target.value} )
    }

    const handleSaveEquation = () => {
        let newArr =  addOrReplace(gameTypeEquation, currentEquation);
        setGameTypeEquation(newArr);
        setCurrentEquation({})

    }



    const handleActive = ( equationId ) => {
            setGameTypeEquation(prev =>{
               return  prev.map(item => item.equationId == equationId ? {...item, active: !item.active} : item )
            } )
    }

    const updateAgent = async (  ) =>{
        const payload = {
            AgentData: {
                agentName: agentData?.agentName,
                userId: follow.userId,
                username: follow.name
            },
            gameTypeEquation: gameTypeEquation
        }

        try {
            dispatch(setIsLoading(true))
            const result = await updateAgentService( payload, agentData.agentId );
            if(result.data) {
              setAgentData(result.data.agentData);
              setGameTypeEquation(result.data.gameTypeEquation)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
            dispatch(setIsLoading(false))
        }
    }

    async function  addNewEquation () {
        try {
            dispatch(setIsLoading(true))
            const result = await addNewEquationForExistedAgent( newEquation, agentId.id );
            if(result.data) {
              setGameTypeEquation([...gameTypeEquation, ...result.data]);
              setShowNewEquation(false)
              setNewEquation([])

            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
            dispatch(setIsLoading(false))
        }
    }

    return (
        <div className='p-4 bg-bgColor h-[88vh]'>
            <div className='flex'>
                <img src={memberLogo} alt='user-Logo' className=' w-6' />
                <span className='ms-2 text-fgColor font-bold'>/ Agent / View</span>
            </div>
            <div className='mt-4 bg-rectangle w-full min-h-[95%] rounded-md'>
                <div className=' p-4 font-semibold h-[800px] overflow-y-scroll'>
                    <button className='text-rectangle bg-primary w-[200px] h-[40px] me-2 rounded-md'>
                        <Link to="/agent" className='flex items-center font-semibold'>
                            <img src={backLogo} alt="" className='w-6 h-4 pe-2 ms-2' />
                            <div className='flex justify-center ms-12'>Back</div>
                        </Link>
                    </button>
                    <div className='w-full flex flex-col justify-center items-center '>
                        <AgentInput
                            handleOnChange={handleOnChange}
                            userData= {userData}
                            setFollow= {setFollow}
                            selectFollower= {selectFollower}
                            follow = {follow}
                            agentData = {agentData}
                            expand = {expand}
                            updateAgent ={updateAgent}
                            showNewEquation={showNewEquation}
                            setShowNewEquation={setShowNewEquation}
                        />


                        <div className='flex items-start justify-between gap-3 w-[90%] flex-wrap text-fgColor overflow-y-auto '>
                            {
                                 gameTypeEquation && gameTypeEquation.map( ( equation ) =>

                                    currentEquation.equationId == equation.equationId
                                     ?
                                    <EditEquationCard

                                        equation={equation}
                                        handleExpand={handleExpand}
                                        currentEquation ={currentEquation}
                                        handleOnChangeEquation ={ handleOnChangeEquation }
                                        handleSaveEquation = { handleSaveEquation }
                                        handleActive = { handleActive }
                                        />
                                    :
                                    <EquationCard
                                        equation={equation}
                                        expandIndex={expandIndex}
                                        setCurrentEquation={setCurrentEquation}
                                        handleExpand= {handleExpand}
                                        handleActive= {handleActive}
                                    />
                                )
                            }
                            {/* {
                editEquation ?
                    <div className='absolute bg-black flex justify-center items-center
                            w-screen h-screen top-0 left-0 bg-opacity-30 z-30'
                            onClick={()=>setEditEquation(false)}
                        >
                        <div className=' bg-bgColor py-4 px-10 rounded-md shadow-lg text-fgColor font-semibold z-auto
                                ' onClick={(e) => e.stopPropagation()}>
                            <div className='mb-2 text-center '>Editing Equation</div>
                            <input type="text" className='px-2 py-2 outline-none mb-2 w-[350px]' value={equation.equation} onChange={(e) => setEquation(e.target.value)} />
                            <div className='flex mt-2 mb-4 text-bgColor'>
                                {
                                    operators.map((operator, key) => (
                                        <div key={key} className='w-[50px] bg-attractive1 text-center py-2 mr-2 rounded-sm' onClick={() => handleEquation(operator)}
                                        >{operator}</div>
                                    ))
                                }
                            </div>
                            <div className='flex justify-end'>
                                <button className='bg-primary text-bgColor w-[100px] mr-2 h-[40px] rounded-sm' onClick={()=>setEditEquation(false)}>Save</button>
                                <button className='bg-attractive2 text-bgColor w-[100px] h-[40px] rounded-sm'
                                    onClick={() => setEditEquation(false)}>Cancel</button>
                            </div>
                        </div>
                    </div> : ""
            } */}
            {showNewEquation &&
              <div onClick={()=> {setShowNewEquation(false)}} className="fixed inset-0 bg-textcol bg-opacity-50  flex justify-center items-center">
                    <div onClick={(e)=> e.stopPropagation()}  className="w-[65%]  bg-white rounded-t-lg bg-white px-12 py-6">
                         <NewGameType gameTypeEquation={newEquation} setGameTypeEquation={setNewEquation} gameTypeData={filterGameType}/>
                         <div className='w-full flex justify-end px-6'>
                            <button
                                className='bg-primary w-[160px] py-2 text-white rounded-md ml-6 mt-6'
                                onClick={ addNewEquation }
                            >
                                Save Equations
                            </button>
                         </div>
                    </div>
              </div>
          }
             </div>
            </div>
                </div>
            </div>

            {/* <div className='h-5'></div> */}
        </div>
    )
}

export default ViewAgent
